
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.25 15a4.875 4.875 0 100-9.75 4.875 4.875 0 000 9.75z","stroke":"#EDC843","stroke-width":"1.5","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M14.569 5.428c.43-.117.875-.177 1.322-.178a4.875 4.875 0 110 9.75M1.5 18.506a8.25 8.25 0 0113.5 0M15.89 15a8.241 8.241 0 016.75 3.506","stroke":"#EDC843","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    